import { apiFetch } from './apiClient';



function fromApi(a) {
  return {
    id:          a.id,
    clienteId:   a.cliente_id,
    descricao:   a.descricao,
    usuario:     a.usuario     ?? '',
    senha:       a.senha       ?? '',
    link:        a.link        ?? '',
    observacoes: a.observacoes ?? '',
    criadoEm:   a.criado_em   ?? '',
  };
}

export async function listarAcessos(clienteId) {
  const data = await apiFetch(`/acessos?cliente_id=${clienteId}`);
  return data.map(fromApi);
}

export async function criarAcesso(dados) {
  return fromApi(await apiFetch('/acessos', { method: 'POST', body: JSON.stringify(dados) }));
}

export async function atualizarAcesso(id, dados) {
  return fromApi(await apiFetch(`/acessos/${id}`, { method: 'PATCH', body: JSON.stringify(dados) }));
}

export async function excluirAcesso(id) {
  await apiFetch(`/acessos/${id}`, { method: 'DELETE' });
}
